import { Capacitor } from "@capacitor/core";
import { OpenFeature } from "@openfeature/web-sdk";
import { LoaderFunction, Outlet, redirect } from "react-router-dom";

import { get } from "api";
import { queryClient } from "pages/Root";
import {
  extractPlatformStatus,
  PlatformAccessStatus,
} from "utils/platformAccessStatus";

import LoadingLayout from "./LoadingLayout";

/**
 * Layout route for anonymous users (pre-login)
 */
const AnonymousLayout = () => {
  return (
    <>
      <LoadingLayout />

      <div className="flex flex-auto">
        <div className="w-full">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export const anonymousLoader: LoaderFunction = async ({ request }) => {
  const successfulPaymentParam = new URL(request.url).searchParams.get(
    "successfulPayment"
  );

  const platform = await queryClient.fetchQuery(["/platform/current"], () =>
    get("/platform/current").catch(() => null)
  );

  // Ensure we have a platform context for feature flagging targeting rules
  OpenFeature.setContext({
    platform: platform
      ? {
          targetingKey: platform.id,
        }
      : null,
  });

  const isNativePlatform = Capacitor.isNativePlatform();

  // If the platform is not active, redirect to the deactivated page
  if (extractPlatformStatus(platform) === PlatformAccessStatus.Deactivated) {
    if (
      (isNativePlatform && !request.url.includes("/signin")) ||
      !isNativePlatform
    ) {
      return redirect("/deactivated");
    }

    return null;
  }

  // If the platform is active and the user is logged in and completed, redirect to the home page
  return await queryClient
    .fetchQuery(["/user"], () => get("/user"))
    .then(({ completedProfile }) => {
      if (!successfulPaymentParam && completedProfile) {
        return redirect("/home");
      } else {
        return null;
      }
    })
    .catch(() => {
      return null;
    });
};

export default AnonymousLayout;
